import { Checkbox } from "../../primitive/checkbox";

import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface FormCheckboxProps extends Omit<
  React.ComponentProps<typeof Checkbox>,
  "checked" | "onCheckedChange"
> {
  text?: string;
  showErrorMessage?: boolean;
}

function FormCheckbox({
  text,
  showErrorMessage = true,
  ...props
}: FormCheckboxProps) {
  const field = useFieldContext<boolean>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Checkbox
          id={field.name}
          checked={field.state.value ?? false}
          onCheckedChange={(checked) => field.handleChange(checked === true)}
          {...props}
        />
        {text ? (
          <label htmlFor={field.name} className="cursor-pointer text-sm">
            {text}
          </label>
        ) : null}
      </div>
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormCheckbox };
